import Vue from "vue";
import Services from "./Services.vue";

export function load() {
  const selector = "services-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(Services, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
